import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
import { CONTENT_URL_AI } from '../../../../../constants';
var AILearnMoreAnchor = function AILearnMoreAnchor(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return fg('platform-linking-fix-a11y-in-smart-card') ? /*#__PURE__*/React.createElement(Link, _extends({
    href: CONTENT_URL_AI,
    target: "_blank",
    rel: "noopener noreferrer"
  }, props), children) :
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
  React.createElement("a", _extends({
    href: CONTENT_URL_AI,
    target: "_blank",
    rel: "noopener noreferrer"
  }, props), children);
};
export default AILearnMoreAnchor;